import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import { createStore, compose, applyMiddleware } from "redux";
import rootReducer from "../reducers";
import createSagaMiddleware from "redux-saga";
import { watchEntity } from "../sagas/entitySaga";
import logger from "redux-logger";
import AxiosGetInstance from "../utils/AxiosApi";
import { devToolsEnhancer } from "redux-devtools-extension";

export default function configureStore(initialState) {
  const sagaMiddleware = createSagaMiddleware();

  let middlewares = [reduxImmutableStateInvariant(), sagaMiddleware];

  if (process.env.NODE_ENV == "development") {
    middlewares.push(logger);
  }

  const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(...middlewares),
      //window.devToolsExtension ? window.devToolsExtension() : f => f //Enable Redux Dev Tools
      devToolsEnhancer({ trace: true })
    )
  );

  //FIX THIS
  //DOING THAT BECAUSE THE FUNCTION GetToken used on every request, gets the token from the window Object
  window.store = store;
  window.axios = AxiosGetInstance();

  //SUPPOSED TO BE LIKE THIS!!!!
  // if(process.env.NODE_ENV == 'development'){
  //     window.store = store;
  //     window.axios = AxiosGetInstance();
  // }
  sagaMiddleware.run(watchEntity);

  return store;
}
